import Vue from 'vue'
import VueRouter from 'vue-router'
import CreateNewTask from "../views/CreateNewTask.vue"
import Login from "../views/Login.vue"
import Signup from "../views/Signup.vue"
import Settings from "../views/Settings.vue"
import TaskList from "../views/ListTask.vue"
import Welcome from "../views/Welcome.vue"
import store from '../store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/agenda/upcoming'
  },
  {
    path: '/agenda/:id',
    name: 'TaskList',
    component: TaskList
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: Welcome
  },
  {
    path: '/new',
    name: 'New',
    component: CreateNewTask
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/settings',
    name: 'Setting',
    component: Settings
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next)=>{
  if (to.name === "Signup" && !store.getters.profile) next()
  else if (to.name !== "Login"  && !store.getters.profile) next({name: "Login"})
  else if (store.getters.profile && (to.name === "Login" || to.name === "Offline")) next(from)
  else next()
})

export default router
